var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "12" } },
        [
          _c("w-input", {
            attrs: { label: _vm.$ct("text"), fancy: "", required: "" },
            model: {
              value: _vm.value.Text,
              callback: function ($$v) {
                _vm.$set(_vm.value, "Text", $$v)
              },
              expression: "value.Text",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("w-date-picker", {
            attrs: { fancy: "", label: _vm.$ct("start-date") },
            model: {
              value: _vm.value.StartDate,
              callback: function ($$v) {
                _vm.$set(_vm.value, "StartDate", $$v)
              },
              expression: "value.StartDate",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("w-date-picker", {
            attrs: { nullable: "", fancy: "", label: _vm.$ct("end-date") },
            model: {
              value: _vm.value.EndDate,
              callback: function ($$v) {
                _vm.$set(_vm.value, "EndDate", $$v)
              },
              expression: "value.EndDate",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("w-select", {
            attrs: {
              fancy: "",
              value: _vm.value.FrequencyType,
              items: _vm.frequencyTypeItems,
              label: _vm.$ct("frequency-type-items"),
            },
            on: {
              input: function ($event) {
                return _vm.setFrequencyType($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("w-input-number", {
            attrs: {
              fancy: "",
              label: _vm.$ct("interval"),
              decimals: 0,
              min: 1,
            },
            model: {
              value: _vm.value.Interval,
              callback: function ($$v) {
                _vm.$set(_vm.value, "Interval", $$v)
              },
              expression: "value.Interval",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { staticClass: "mts", attrs: { xs: "12" } },
        [
          _c("app-task-priority-chips", {
            attrs: { label: _vm.$ct("priority") },
            model: {
              value: _vm.value.Priority,
              callback: function ($$v) {
                _vm.$set(_vm.value, "Priority", $$v)
              },
              expression: "value.Priority",
            },
          }),
        ],
        1
      ),
      _vm.isWeekly
        ? _c("app-settings-weekly", {
            attrs: { value: _vm.value, xs: "12", md: "12" },
          })
        : _vm.isMonthly
        ? _c("app-settings-monthly", {
            attrs: { value: _vm.value, xs: "12", md: "12" },
          })
        : _vm.isMonthlyPerWeek
        ? _c("app-settings-monthly-per-week", {
            attrs: { value: _vm.value, xs: "12", md: "12" },
          })
        : _vm.isYearly
        ? _c("app-settings-yearly", {
            attrs: { value: _vm.value, xs: "12", md: "12" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }